import { FileFetchingDetails, IntegrationData, PlatformIntegrationData } from "../Integrations.types"
import {
	integrationListCVList,
	integrationGetCVContent,
	integrationGetUserDetails,
} from "shared/src/libs/apiLib/apiLib"

export const arcrmIntegrationData: PlatformIntegrationData<
	"setupUser" | "candidateProfile" | "chooseFile" | "fetchFile" | "confirmationPage"
> = {
	allowChat: true,
	parameterMapping: {
		externalClientId: "externalClientId",
		clientId: "clientId",
		externalId: "externalId",
		userId: "userId",
	},
	pages: ["setupUser", "candidateProfile", "chooseFile", "fetchFile", "confirmationPage"],
	props: {
		setupUser: {
			getUserDetails: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationGetUserDetails(integrationData, clientId)
			},
		},
		fetchFile: {
			getFile: async (clientId: string, integrationData: IntegrationData, fileFetchingDetails: FileFetchingDetails) => {
				return await integrationGetCVContent(integrationData, fileFetchingDetails, clientId)
			},
		},
		chooseFile: {
			listFiles: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationListCVList(integrationData, clientId)
			},
		},
		candidateProfile: {},
	},
	initialData: {},
	useFrontendFileUpload: false,
}
